<loader *ngIf="loading"></loader>

<div class="statement-bar">
  <button
    class="t-button t-button--flat statement-btn"
    (click)="printStatement()"
    [disabled]="!canPrintStatement || statementLoading"
  >
    <i class="fas fa-file-pdf"></i>
    {{ "translate.reports.statementPdf" | translate }}
  </button>
  <spinner *ngIf="statementLoading"></spinner>
  <span *ngIf="!canPrintStatement" class="statement-hint">
    {{ "translate.reports.validateClinic" | translate }}
  </span>
</div>

<ui-table
  *ngIf="data"
  [data]="data"
  [isWrapped]="false"
  [tblColor]="true"
  [tblRoundBottom]="true"
  (requestUpdate)="loadDataOnPagination($event)"
  [totalRecords]="searchMetaData.totalRecords"
  [numberOfRows]="numberOfRows"
  [displayFilter]="[
    'balRef',
    'balDocKind',
    'balDateFormatted',
    'balValueDateFormatted'
  ]"
  [templates]="[
    {
      title: 'translate.general.clinic',
      template: clinicDescr,
      permission: !clinicUserSw
    },
    {
      title: 'translate.general.balDebtSum',
      template: balDebtSum
    },
    {
      title: 'translate.general.balCreditSum',
      template: balCreditSum
    },
    {
      title: 'translate.general.balance',
      template: balance
    }
  ]"
></ui-table>

<ng-template #balDebtSum let-row="row">
  <span
    *ngIf="row.balDebtSum"
    class="l-num l-ta-right"
    >{{ row.balDebtSum | currency: "ILS" }}</span
  >
</ng-template>

<ng-template #balCreditSum let-row="row">
  <span
    *ngIf="row.balCreditSum"
    class="l-num l-ta-right"
  >
    {{ row.balCreditSum | currency: "ILS" }}</span
  >
</ng-template>

<ng-template #balance let-row="row">
  <div *ngIf="row.balance" class="l-num l-ta-right">
    {{ row.balance | currency: "ILS" }}
  </div>
</ng-template>

<ng-template #clinicDescr let-row="row">
  {{ row.clinicDescr }}
</ng-template>
